import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n    height: 159px;\n  "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    height: 239px;\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n    height: 318px;\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n\n  height: 372px;\n  ", "\n  ", "\n  ", "\n\n  > img {\n    height: 100%;\n    mix-blend-mode: multiply;\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n    text-align: left;\n    order: 1;\n  "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  font-family: Inter;\n  line-height: 160%;\n  color: #4f6e7c;\n\n  width: 50%;\n  text-align: right;\n\n  font-size: 18px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    width: 100%;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 300;\n  line-height: 100%;\n  color: #2c2c2c;\n  font-family: \"Sofia thin\";\n  text-transform: capitalize;\n\n  width: 50%;\n  text-align: left;\n\n  font-size: 24px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n          transform: translate(50%, 50%) scale(calc(64 / 48));\n        "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    max-width: 272px;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  background: #f5f1f2;\n  text-align: center;\n  max-height: 32rem;\n  height: 100%;\n  transition: 0.3s;\n  max-width: 342px;\n  ", "\n  ", "\n\n  @media (hover: hover) {\n    :hover {\n      background-color: #ffffff;\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n      ", " {\n        opacity: 0.6;\n      }\n      ", " {\n        right: 50%;\n        bottom: calc(50% + 30px);\n        transform-origin: center;\n        background: #c34c3e;\n\n        transform: translate(50%, 50%) scale(calc(82 / 48));\n        ", "\n      }\n      ", " {\n        opacity: 1;\n      }\n    }\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n    margin: 0;\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-family: Inter;\n  line-height: 19px;\n  color: #839098;\n  text-transform: capitalize;\n  text-align: left;\n  margin-top: 9px;\n  \n  font-size: 16px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(20 / 48)); // 30 9\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(30 / 48)); // 30 13\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(40 / 48)); // 40 18\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.3s;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #4f6e7c;\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  transform-origin: 68px 68px;\n  ", "\n  ", "\n  ", "\n  &::after {\n    content: \"\";\n    width: 38%;\n    height: 38%;\n    background-image: url(", ");\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  right: 50%;\n  transform: translateX(50%);\n  top: 1px;\n\n  font-family: Inter;\n  line-height: 160%;\n\n  color: #ffffff;\n  opacity: 0;\n  transition: opacity 0.3s;\n  z-index: 1;\n  top: calc(50% + 30px);\n\n  font-size: 16px;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px;\n\n    flex-direction: column;\n    align-items: start;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 15px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 24px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #2c2c2c;\n  mix-blend-mode: normal;\n  opacity: 0;\n  transition: 0.3s;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import pensileImage from "images/pensile.svg";
export var Overlay = styled.div(_templateObject());
export var Bottom = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()), media.xLargeScreen(_templateObject4()), media.smallScreen(_templateObject5()));
export var Customize = styled.span(_templateObject6(), media.xxLargeScreen(_templateObject7()));
export var Pensile = styled.div(_templateObject8(), media.xxLargeScreen(_templateObject9()), media.xLargeScreen(_templateObject10()), media.smallScreen(_templateObject11()), pensileImage);
export var Category = styled.p(_templateObject12(), media.xxLargeScreen(_templateObject13()), media.xLargeScreen(_templateObject14()), media.smallScreen(_templateObject15()));
export var Wrapper = styled.div(_templateObject16(), media.xxLargeScreen(_templateObject17()), media.xLargeScreen(_templateObject18()), Overlay, Pensile, media.xxLargeScreen(_templateObject19()), Customize);
export var Title = styled.h4(_templateObject20(), media.xxLargeScreen(_templateObject21()), media.xLargeScreen(_templateObject22()), media.smallScreen(_templateObject23()));
export var Price = styled.p(_templateObject24(), media.xxLargeScreen(_templateObject25()), media.xLargeScreen(_templateObject26()), media.smallScreen(_templateObject27()));
export var Image = styled.div(_templateObject28(), media.xxLargeScreen(_templateObject29()), media.xLargeScreen(_templateObject30()), media.smallScreen(_templateObject31()));